<template>
    <div>
        <Zakazka
            v-if="menuItem === 0"
            :isEditor="isEditor"
            :isAdmin="isAdmin"
            :isManager="isManager"
            :isProjektant="isProjektant"
            :idUser="idUser"
            @gotoPodani = "gotoPodani"
            @gotoStanoviska = "gotoStanoviska"
        />

        <Podani
            v-if="menuItem === 1 || menuItem === 10"
            :isEditor="isEditor"
            :isAdmin="isAdmin"
            :isManager="isManager"
            :isInvestor="isInvestor"
            :isProjektant="isProjektant"
            :idUser="idUser"
            :idZakazka="idZakazka"
            :showStanoviska="menuItem === 10"
            @gotoPodani = "gotoPodani"
            @gotoStanoviska = "gotoStanoviska"
            @gotoNewPodani = "gotoNewPodani"
        />
        
        <EditPodani
            v-if="menuItem === 2"
            :itemId="-1"
            :isEditor="isEditor"
            :isAdmin="isAdmin"
            :idUser="idUser"
            :idZakazka="idZakazka"
            :idPodani="idPodani"
            @gotoPodani = "gotoPodani"
        />

        <Uzivatel
            v-if="menuItem === 3"
        />

        <Ciselnik
            v-if="menuItem === 4 || menuItem === 5 || menuItem === 6 || menuItem === 7 || menuItem === 8 || menuItem === 9"
            :menuItem="menuItem"
            :isEditor="isEditor"
            :isAdmin="isAdmin"
        />
    </div>
</template>

<script>
    import Zakazka from './zakazka/Zakazka.vue'
    import Podani from './podani/Podani.vue'
    import EditPodani from './podani/EditPodani.vue'
    import Uzivatel from './uzivatel/Uzivatel.vue'
    import Ciselnik from './ciselnik/Ciselnik.vue'

    export default {
        name: 'Main-Component',
        props: ['menuItem', 'isEditor', 'isAdmin', 'isManager', 'isInvestor', 'isProjektant', 'idUser', 'idZakazka'],
        components: {
            Zakazka,
            Podani,
            EditPodani,
            Uzivatel,
            Ciselnik
        },
        data() {
            return {
                idPodani: -1
            }
        },
        watch: {
            idZakazka(newVal) {
                if (newVal === -1) {
                    this.idPodani = -1
                }
            }
        },
        methods: {
            gotoPodani(idzakazka) {
                this.$emit('setMenuItem', 1, idzakazka)
            },
            gotoStanoviska(idzakazka) {
                this.$emit('setMenuItem', 10, idzakazka)
            },
            gotoNewPodani(idzakazka, idpodani) {
                this.idPodani = idpodani
                this.$emit('setMenuItem', 2, idzakazka)
            }
        }
    }
</script>